import { sortBy } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'
import { getTourV2ExperienceItems } from '../tourV2ExperienceCartItems'
import { CHECKOUT_ITEM_TYPE_TOUR_V2_EXPERIENCE } from 'constants/checkout'
import { getCurrentIntl } from 'i18n/util/currentIntl'

const getTourV2ExperienceItemsViews = createSelector(
  (state: App.State) => getTourV2ExperienceItems(state),
  (tourExperienceItems): App.WithDataStatus<Array<App.Checkout.TourV2ExperienceItemView>> => {
    if (tourExperienceItems.length === 0) { return { hasRequiredData: true, data: [] } }
    const intl = getCurrentIntl()
    const tourExperienceItemView = sortBy(
      tourExperienceItems.map((item): App.Checkout.TourV2ExperienceItemView => ({
        title: item.purchasableOption.name ?? '',
        kind: CHECKOUT_ITEM_TYPE_TOUR_V2_EXPERIENCE,
        packageId: item.purchasableOption.fkExperienceId!,
        uniqueKey: item.purchasableOption.fkExperienceId!,
        item,
        loyalty: {
          productType: 'tour_optional_extra',
        },
        primaryTitle: item.purchasableOption.name ?? '',
        removeLabel: intl.formatMessage({
          id: 'LH2T0OPxKAmmfSNUwK18',
          defaultMessage: 'Remove',
          description: 'Label for removing a tour experience item from checkout',
        }),
        totals: {
          price: item.total ?? 0,
          memberPrice: 0,
          value: 0,
          surcharge: 0,
          taxesAndFees: 0,
          memberValue: 0,
          extraGuestSurcharge: 0,
        },
      })),
      item => item.item.purchasableOption.day,
      'asc',
    )
    return {
      hasRequiredData: true,
      data: tourExperienceItemView,
    }
  },
)

export default getTourV2ExperienceItemsViews
